import { useRecoilState } from 'recoil';

import { history } from '_helpers';
import { authAtom } from '_state';
import { useAlertActions } from '_actions';

export { useFetchWrapper };



function useFetchWrapper() {
    // const authWrapper = useAuthWrapper();
    const [auth, setAuth] = useRecoilState(authAtom);
    const alertActions = useAlertActions();

    return {
        get:         request('GET'),
        post:        request('POST'),
        put:         request('PUT'),
        delete:      request('DELETE'),
        requestFile: request('GET', /*skipJsonCheck=*/true)
    };

    function request(method, skipJsonCheck = false) {

        async function requestor(url, header, body) {
            var myHeaders = new Headers();
            if (header) myHeaders.append("Content-Type", header);
            const requestOptions = {
                method: method,
                mode: "cors",
                headers: myHeaders,
                redirect: 'follow',
                credentials: 'include',
            };
            if (body) {
                requestOptions.headers['Content-Type'] = header;
                requestOptions.body = body;
            }
            return await fetch(url, requestOptions);
        }

        return async (url, header, body) => {
            let response = await requestor(url, header, body);
            if (!skipJsonCheck) {
                try {
                    let rawjson = await response.clone().json();
                    if (url !== "/api/profile/me" && "message" in rawjson) {
                        const authError = rawjson.message?.name;
                        if (rawjson.status === "Error" && (
                            authError === "TokenNotFound" ||
                            authError === "TokenInvalid" ||
                            authError === "UserNotFound" ||
                            authError === "SessionExpired"
                        )) {
                            setAuth(null);
                            localStorage.clear();
                        }
                    }
                } catch (e) {
                    // Response body is not JSON (e.g. file download, plain-text error) — that is OK.
                }
            }
            return response;
        }
    }
}
